export default __webpack_public_path__ + "static-json/ne_110m_rivers_lake_centerlines-ecf7a4ecafd175ebd496c3ed8c847948.json";